import { deleteCoreDataDictionaryViewsSharedKeyAsyncSlice } from './delete';
import { getCoreDataDictionaryViewsSharedKeyAsyncSlice } from './get';
import { postCoreDataDictionaryViewsSharedKeyAsyncSlice } from './post';

export const { requestDeleteCoreDataDictionaryViewsSharedKey, resetDeleteCoreDataDictionaryViewsSharedKey } =
	deleteCoreDataDictionaryViewsSharedKeyAsyncSlice.asyncActionCreators;

export const { requestGetCoreDataDictionaryViewsSharedKey, resetGetCoreDataDictionaryViewsSharedKey } =
	getCoreDataDictionaryViewsSharedKeyAsyncSlice.asyncActionCreators;

export const { requestPostCoreDataDictionaryViewsSharedKey, resetPostCoreDataDictionaryViewsSharedKey } =
	postCoreDataDictionaryViewsSharedKeyAsyncSlice.asyncActionCreators;
